export default __webpack_public_path__ + "8e268ccc1664ce41b3d7391ac28b446d.svg";